"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecToggleWishlistItem = void 0;
const enums_1 = require("../enums");
const buildGA4ProductDetail_1 = require("./buildGA4ProductDetail");
const clearGA4EventData_1 = require("./clearGA4EventData");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackEecToggleWishlistItem({ product, quantity, variant, eventName, itemListName, }) {
    (0, clearGA4EventData_1.clearGA4EventData)();
    const eventData = (0, buildGA4ProductDetail_1.buildGA4ProductDetailInteraction)({
        eventName,
        featureCategory: enums_1.GA4FeatureCategory.Ecommerce,
        product,
        variant,
        quantity,
        itemListName,
    });
    const eecData = {
        event: eventName === enums_1.GA4EventName.AddToWishlist
            ? enums_1.EventName.EECAddToWishlist
            : enums_1.EventName.EECRemoveFromWishlist,
        eventAction: eventName === enums_1.GA4EventName.AddToWishlist
            ? enums_1.EventAction.AddToWishlist
            : enums_1.EventAction.RemoveFromWishlist,
        eventCategory: enums_1.EventCategory.Wishlist,
        eventLabel: product.manufacturerSku,
        nonInteraction: false,
        ...eventData,
    };
    (0, pushToDataLayer_1.pushToDataLayer)(eecData);
}
exports.trackEecToggleWishlistItem = trackEecToggleWishlistItem;
//# sourceMappingURL=trackEecToggleWishlistItem.js.map